<div class="submit-ticket-page p-4 bg-white rounded-4" style="max-width: 555px; width: 100%;">
  <!-- Header -->
  <div class="dialog-header d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
    <div class="d-flex align-items-center gap-3">
      <div class="dialog-header-icon">
        <mat-icon>confirmation_number</mat-icon>
      </div>
      <div>
        <h3 class="dialog-title mb-0 fw-bold">Submit Ticket</h3>
        <p class="dialog-subtitle mb-0">Create a support ticket, upload evidence, and assign staff.</p>
      </div>
    </div>
    <button type="button" mat-icon-button class="dialog-close-btn flex-shrink-0" (click)="closeView()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <form [formGroup]="raiseReuqestForm" class="ticket-form">
      <!-- Section 1: Attachment -->
      <div class="dialog-section-bar mb-3">
        <div class="section-icon-circle">
          <mat-icon>cloud_upload</mat-icon>
        </div>
        <h4 class="section-bar-title mb-0">Upload Photo or Video</h4>
      </div>

      <div class="media-upload" (click)="mediaInput.click()">
        <input
          #mediaInput
          type="file"
          accept="image/*,video/*"
          class="media-input"
          style="display: none;"
          (change)="onFileSelect($event)"
        />

        <ng-container *ngIf="!issuePhotoPreview && !issueVideoPreview; else mediaPreview">
          <div class="media-placeholder">
            <span class="media-icon">
              <mat-icon>add_photo_alternate</mat-icon>
            </span>
            <p class="media-title">Add Photo or Video</p>
            <p class="media-subtitle">Tap to upload media (PNG, JPG, MP4)</p>
          </div>
        </ng-container>

        <ng-template #mediaPreview>
          <div class="media-preview" (click)="$event.stopPropagation()">
            <img *ngIf="issuePhotoPreview" [src]="issuePhotoPreview" alt="Uploaded preview" />
            <video *ngIf="issueVideoPreview" [src]="issueVideoPreview" controls></video>
            <button type="button" mat-icon-button class="delete-media" (click)="deleteFile()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </ng-template>
      </div>
      <div
        class="field-error"
        *ngIf="raiseReuqestForm.get('issue_photo')?.hasError('required') && raiseReuqestForm.get('issue_photo')?.touched">
        Photo or video is required
      </div>

      <!-- Section 2: Ticket Details -->
      <div class="dialog-section-bar mb-3 mt-3">
        <div class="section-icon-circle">
          <mat-icon>info</mat-icon>
        </div>
        <h4 class="section-bar-title mb-0">Ticket Details</h4>
      </div>

      <div class="form-row">
        <div class="form-col" [class.form-col--full]="!showSubCategory">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Category"
              formControlName="issue_category_id"
              [options]="categoryList | searchableOptions:'issue_category':'issue_category_id'"
              placeholder="Select Category"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
            <div
              class="field-error"
              *ngIf="raiseReuqestForm.get('issue_category_id')?.hasError('required') && raiseReuqestForm.get('issue_category_id')?.touched">
              Category is required
            </div>
          </div>
        </div>

        <div class="form-col" *ngIf="showSubCategory">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Sub Category"
              formControlName="sub_issue_category_id"
              [options]="subCategoryList | searchableOptions:'issue_category':'issue_category_id'"
              placeholder="Select Subcategory"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
            <div
              class="field-error"
              *ngIf="raiseReuqestForm.get('sub_issue_category_id')?.hasError('required') && raiseReuqestForm.get('sub_issue_category_id')?.touched">
              Sub Category is required
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-col form-col--full">
          <label class="form-label small fw-semibold text-secondary mb-1">
            Description <span class="text-danger">*</span>
          </label>
          <div
            class="description-field"
            [class.description-field--error]="raiseReuqestForm.get('description')?.hasError('required') && raiseReuqestForm.get('description')?.touched">
            <textarea
              rows="3"
              formControlName="description"
              placeholder="Enter detailed description about this ticket..."
              class="description-input"
            ></textarea>
            <div
              class="field-error"
              *ngIf="raiseReuqestForm.get('description')?.hasError('required') && raiseReuqestForm.get('description')?.touched">
              Description is required
            </div>
          </div>
        </div>
      </div>

      <!-- Section 3: Assignment & Status -->
      <div class="dialog-section-bar mb-3 mt-3">
        <div class="section-icon-circle">
          <mat-icon>assignment_ind</mat-icon>
        </div>
        <h4 class="section-bar-title mb-0">Assignment & Status</h4>
      </div>

      <div class="form-row">
        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Project"
              formControlName="account_id"
              [options]="projectList | searchableOptions:'project_name':'account_id'"
              placeholder="Select Project"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>

        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Status"
              formControlName="status"
              [options]="statusList | searchableOptions:'status':'status_id'"
              placeholder="Select Status"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Internal Priority"
              formControlName="priority_id"
              [options]="priorityList | searchableOptions:'priority':'priority_id'"
              placeholder="Select Internal Priority"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>

        <div class="form-col">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Role"
              formControlName="role_id"
              [options]="roleList | searchableOptions:'role':'role_id'"
              placeholder="Select Role"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-col form-col--full">
          <div class="form-field-wrap">
            <app-searchable-dropdown
              label="Member"
              formControlName="assigned_to"
              [options]="allMembers | searchableOptions:'member_name':'user_id'"
              placeholder="Select Member"
              class="w-100 ticket-dropdown"
            ></app-searchable-dropdown>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="dialog-actions d-flex justify-content-end gap-2 pt-3 border-top mt-3">
    <button type="button" class="btn btn-outline-secondary rounded-pill px-4" (click)="closeView()">Cancel</button>
    <button
      type="button"
      class="gold-button"
      (click)="submitRequest()"
      [disabled]="submitting">
      {{ submitting ? 'Submitting...' : 'Submit' }}
    </button>
  </div>
</div>
